
/* ============================== src/utils/passwordPolicy.js ============================== */
/**
 * Правила валидации паролей (UX-зеркало серверной логики).
 *
 * Единая точка правды для формы входа и модалки смены пароля.
 * Возвращает список требований для отрисовки UI и флаг валидности.
 */

export function checkPasswordStrength(password) {
  const issues = [
    { ok: password.length >= 8, t: "Минимум 8 символов" },
    { ok: /[A-ZА-ЯЁ]/.test(password), t: "Заглавная буква" },
    { ok: /[a-zа-яё]/.test(password), t: "Строчная буква" },
    { ok: /\d/.test(password), t: "Цифра" },
    { ok: /[^A-Za-zА-Яа-яЁё0-9]/.test(password), t: "Специальный символ" },
  ];

  return {
    issues,
    isValid: issues.every((i) => i.ok),
  };
}
